import { MatDateFormats } from "@angular/material";
const MOMENT_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: "ll"
    },
    display: {
        dateInput: "ll",
        monthYearLabel: "MMMM Y",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM Y"
    }
};

const dateNames: string[] = [];
for (let date = 1; date <= 31; date++) {
    dateNames.push(String(date));
}

export { MOMENT_DATE_FORMATS, dateNames };



// WEBPACK FOOTER //
// ./src/app/date-formats/moment-date-formats.ts